import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import Game from 'Game';
import { queueEventOfferAssets } from 'State/Events/EventHelper';
import { IAPStateHelper } from 'State/Player/IAP/IAPStateHelper';
import { getWeeklySundayOfferData } from 'Utility/Helpers/IAP/getWeeklySundayOfferData';
import { ISpecialOfferData } from 'Utility/Helpers/IAP/ISpecialOfferData';
import { PopupOfferType } from 'Utility/Helpers/IAP/PopupOffers';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';

// TODO: Currently there is no way for an individual event offer to modify its priority within these offers
export const SPECIAL_OFFERS: Record<PopupOfferType, ISpecialOfferData> = {
    [PopupOfferType.EVENT_OFFER]: {
        priority: 100,
        condition: IAPStateHelper.isEventOfferAvailable,
        preload: queueEventOfferAssets,
        show: IAPStateHelper.showEventOfferPopup,
    },
    [PopupOfferType.SUNDAY_OFFER]: {
        priority: 100,
        condition: IAPStateHelper.isSundayOfferAvailable,
        preload: () => {
            const state = Game.store.getState();
            const {
                dragonbonesName: weeklyOfferDBName,
                dragonbonesPath: weeklyOfferDBPath,
                layoutFileName,
            } = getWeeklySundayOfferData(state);
            addDragonbonesResources(weeklyOfferDBName, weeklyOfferDBPath);
            Game.resource.add('atlas-sunday-offer', 'resource/graphics/sprite_sheets/sunday_offer_v2.json');
            Game.resource.add('SundayOfferLayout', `resource/data/ui/${layoutFileName}.json`);
        },
        preloadCondition: IAPStateHelper.shouldLoadSundayOfferAssets,
        show: IAPStateHelper.showSundayOfferPopup,
    },
    [PopupOfferType.PAYER_REACTIVATION_OFFER]: {
        priority: 10,
        condition: IAPStateHelper.isPayerReactivationOfferAvailable,
        preload: () => {
            Game.resource.add(
                'payer_reactivation_offer',
                'resource/graphics/sprite_sheets/payer_reactivation_offer.json'
            );

            addDragonbonesResources('limited_offer_1', `${DRAGONBONES_PATH}/PayerReactivationOffer/`);
        },
        show: IAPStateHelper.showPayerReactivationPopup,
    },
    [PopupOfferType.STARTER_OFFER]: {
        priority: 0,
        condition: IAPStateHelper.isStarterPackOfferAvailable,
        preload: () => {},
        show: IAPStateHelper.showStarterPackOfferPopup,
        forceShowIfAlreadySeen: true,
    },
};
